/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceQuoteLineResource } from './';
import {
    FixedPriceQuoteLineResourceFromJSON,
    FixedPriceQuoteLineResourceFromJSONTyped,
    FixedPriceQuoteLineResourceToJSON,
} from './';
import type { QuoteScopeComputedValuesResource } from './';
import {
    QuoteScopeComputedValuesResourceFromJSON,
    QuoteScopeComputedValuesResourceFromJSONTyped,
    QuoteScopeComputedValuesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteDetailsResource
 */
export interface FixedPriceQuoteDetailsResource {
    /**
     * 
     * @type {Array<FixedPriceQuoteLineResource>}
     * @memberof FixedPriceQuoteDetailsResource
     */
    quoteLines?: Array<FixedPriceQuoteLineResource>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteDetailsResource
     */
    additionalNotes?: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteDetailsResource
     */
    vatPercent?: number;
    /**
     * 
     * @type {QuoteScopeComputedValuesResource}
     * @memberof FixedPriceQuoteDetailsResource
     */
    computedValues?: QuoteScopeComputedValuesResource;
}

/**
 * Check if a given object implements the FixedPriceQuoteDetailsResource interface.
 */
export function instanceOfFixedPriceQuoteDetailsResource(value: object): value is FixedPriceQuoteDetailsResource {
    return true;
}

export function FixedPriceQuoteDetailsResourceFromJSON(json: any): FixedPriceQuoteDetailsResource {
    return FixedPriceQuoteDetailsResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(FixedPriceQuoteLineResourceFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
        'computedValues': json['computedValues'] == null ? undefined : QuoteScopeComputedValuesResourceFromJSON(json['computedValues']),
    };
}

export function FixedPriceQuoteDetailsResourceToJSON(value?: FixedPriceQuoteDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => FixedPriceQuoteLineResourceToJSON(v))),
        'additionalNotes': value['additionalNotes'],
        'vatPercent': value['vatPercent'],
        'computedValues': QuoteScopeComputedValuesResourceToJSON(value['computedValues']),
    };
}

